import { getCookie, simulateAsyncOperation, throttle } from "mmbclient/Common/CommonFunctions";
import { getClientBalance } from "mmbclient/Common/CommonRazorPay";
import { checkSession } from "mmbclient/Common/CommonService";
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, EP, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, MMB, MMB_LIVE, PAGE_LOADING_TIME, TRACKING_REPORT, US, USER_TYPE_COOKIE_NAME, WALLET } from "mmbclient/Common/CommonVariable";
import { useContext, useEffect, useState } from "react";

const TrackingController = (store) => {

    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState(null); // Stores the server response error
    const [objectURL, setObjectURL] = useState(null); // Stores the current Blob URL
    const wallet = useContext(WALLET);

    const [formValues, setFormValues] = useState({
        searchType: true,
        awbNo: '',
        fwdNo: '',
        client: '',
        invoiceNo: '',
        bookingDate: '',
        service: '',
        billingWt: '',
        destination: '',
        pkt: '',
        consignorName: '',
        consignorPhone: '',
        consigneeName: '',
        consigneePhone: '',
        deliveryDate: '',
        deliveryStatus: '',
        receivedBy: '',
        remarks: '',
    });

    useEffect(() => {
        // Fetch data from server
        const fetchData = async () => {

            setLoading(true);
            try {
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                } else {
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        return () => {
            if (objectURL) {
                URL.revokeObjectURL(objectURL);
            }
        };
    }, [objectURL]);

    const loggerFunc = () => {
        checkSession(store);
    //    getClientBalance(wallet);
    }

    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    const handleInputChange = ((event) => {
        const { name, value } = event.target;

        if (name === 'rdBtnAwbNo') {
            setFormValues({ ...formValues, 'searchType': true, 'fwdNo': '' });
        } else if (name === 'rdBtnFwdNo') {
            setFormValues({ ...formValues, 'searchType': false, 'awbNo': '' });
        } else if (name === 'awbNo') {
            // Allow only alphanumeric, no spaces, and length <= 25
            const regex = /^[a-zA-Z0-9.]*$/; // Matches alphanumeric characters only
            if (regex.test(value) && value.length <= 25) {
                setFormValues({ ...formValues, [name]: value.toUpperCase() });
            }
        } else if (name === 'fwdNo') {
            // Allow only alphanumeric, no spaces, and length <= 25
            const regex = /^[a-zA-Z0-9]*$/; // Matches alphanumeric characters only
            if (regex.test(value) && value.length <= 25) {
                setFormValues({ ...formValues, [name]: value.toUpperCase() });
            }
        }


    });

    const handleSearch = async () => {

        // Check if the end date is earlier than the start date
        if (formValues.awbNo.length === 0 && formValues.fwdNo.length === 0) {
            alert("Please enter docket no.");
            return;
        }

        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }

        setLoading(true);
        // clear fields
        setFormValues({
            ...formValues,
            client: '',
            invoiceNo: '',
            service: '',
            bookingDate: '',
            billingWt: '',
            destination: '',
            pkt: '',
            consignorName: '',
            consignorPhone: '',
            consigneeName: '',
            consigneePhone: '',
            deliveryDate: '',
            deliveryStatus: '',
            receivedBy: '',
            remarks: '',
        });
        // clear print shipper url and error
        if (objectURL) {
            URL.revokeObjectURL(objectURL);
            setObjectURL(null);
        }
        if (error) {
            setError(null);
        }

        try {
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
            const Data = "Data";

            if (c.length === 4) {
                const userKey = c[0];
                const clientCode = c[1];
                const userType = getCookie(APP_TYPE_COOKIE_NAME);

                let cols = "";
                if (MMB === userType) {
                    cols = "db.awb_no as awb_no, db.fwd_no as forwarding_no, db.invoice_no as invoice_no, DATE_FORMAT(db.boking_dt, '%d-%b-%Y') as booking_date, db.bil_wt as billing_weight, db.pkgs as packets, DATE_FORMAT(db.delv_date, '%d-%b-%Y') as delivery_date, db.recv_detail as received_by, db.dlv_remarks as delivery_remarks, db.client_cd as client_code, IFNULL(cm.client_nm,'') as client_name, db.service as service_code, IFNULL(sm.ser_group_code,'') as service_group_code, db.destination as destination, db.destination_code as destination_code, IFNULL(cim.CIT_NM,'') as destination_name, db.ship_ph as db_consignor_phone, IFNULL(cnsr.ship_ph, '') as consignor_phone, IFNULL(cnsr.ship_name, '') as consignor_name, db.recv_ph as db_consignee_phone, IFNULL(cnee.recv_ph, '') as consignee_phone, IFNULL(cnee.recv_name, '') as consignee_name, db.delv_status as delivery_code, IFNULL(dsm.delivery_name,'') as delivery_name";
                } else if (MMB_LIVE === userType) {
                    cols = "db.awb_no as awb_no, db.forwarding_no as forwarding_no, db.invoice_no as invoice_no, DATE_FORMAT(db.booking_date, '%d-%b-%Y') as booking_date, db.billing_weight as billing_weight, db.packets as packets, DATE_FORMAT(db.delivery_date, '%d-%b-%Y') as delivery_date, db.received_by as received_by, db.delivery_remarks as delivery_remarks, db.client_code as client_code, IFNULL(cm.client_name,'') as client_name, db.service_code as service_code, IFNULL(sm.group_code,'') as service_group_code, IFNULL(cim.city_name,'') as destination, db.destination_city as destination_code, IFNULL(cim.city_name,'') as destination_name, db.consignor_phone as db_consignor_phone, IFNULL(cnsr.consignor_phone, '') as consignor_phone, IFNULL(cnsr.consignor_name, '') as consignor_name, db.consignee_phone as db_consignee_phone, IFNULL(cnee.consignee_phone, '') as consignee_phone, IFNULL(cnee.consignee_name, '') as consignee_name, db.delivery_status as delivery_code, IFNULL(dsm.delivery_name,'') as delivery_name";
                }

                let filter = "where";
                if (formValues.awbNo.length === 0) {
                    if (MMB === userType) {
                        filter += " db.fwd_no = '" + formValues.fwdNo + "'";
                    } else if (MMB_LIVE === userType) {
                        filter += " db.forwarding_no = '" + formValues.fwdNo + "'";
                    }
                } else if (formValues.fwdNo.length === 0) {
                    filter += " db.awb_no = '" + formValues.awbNo + "'";
                }
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                } else if (getCookie(USER_TYPE_COOKIE_NAME) === US) {
                    if (MMB === userType) {
                        filter += " and db.client_cd = '" + clientCode + "'";
                    } else if (MMB_LIVE === userType) {
                        filter += " and db.client_code = '" + clientCode + "'";
                    }
                }

                const query = { "beanname": Data, "column": cols, "value": filter, userType: userType, userKey: userKey };
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query),
                        key: "checkService"
                    })
                };
                const path = API_PATH + TRACKING_REPORT + "get";
                const res = await fetch(path, requestOptions);
                const data = await res.json();
                const response = data[0].Data;
                if (response.length > 0 && response !== "Result Not Found") {
                    // ger print shipper pdf
                    const query1 = { "value": filter, userType: userType, userKey: userKey };
                    const requestOptions1 = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: new URLSearchParams({
                            query: JSON.stringify(query1),
                            key: "checkService"
                        })
                    };
                    const path1 = API_PATH + TRACKING_REPORT + "getprintshipper";
                    console.log({path1}+"-----"+JSON.stringify(query1)+"-----------"+JSON.stringify({requestOptions1}));

                    const res1 = await fetch(path1, requestOptions1);

                    // Check if the response is binary (PDF) or a string
                    const contentType = res1.headers.get('Content-Type');

                    // Check if the response is likely binary (PDF file or any binary data)
                    if (contentType && contentType.includes('application/octet-stream')) {
                        const arrayBuffer = await res1.arrayBuffer();
                        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);
                        setObjectURL(url);
                    } else {
                        // If it's a string (plain text or JSON), handle as text
                        const textData = await res1.text(); // Read response as text (string)
                        setError(textData);
                    }

                    // set form values
                    setFormValues({
                        ...formValues,
                        client: response[0].client_name + " | " + response[0].client_code,
                        invoiceNo: response[0].invoice_no,
                        service: response[0].service_group_code,
                        bookingDate: response[0].booking_date,
                        billingWt: response[0].billing_weight,
                        destination: response[0].destination_code === '' ? response[0].destination : response[0].destination_name + " | " + response[0].destination_code,
                        pkt: response[0].packets,
                        consignorName: response[0].consignor_phone === '' ? response[0].db_consignor_phone : response[0].consignor_name,
                        consignorPhone: response[0].consignor_phone,
                        consigneeName: response[0].consignee_phone === '' ? response[0].db_consignee_phone : response[0].consignee_name,
                        consigneePhone: response[0].consignee_phone,
                        deliveryDate: response[0].delivery_date,
                        deliveryStatus: response[0].delivery_name,
                        receivedBy: response[0].received_by,
                        remarks: response[0].delivery_remarks,
                    });
                } else {
                    setModalMessage('Data not found');
                    setModalType('danger');
                    setShowModal(true);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setLoading(false);
    };

    const handleReset = async () => {
        // clear fields
        setFormValues({
            ...formValues,
            searchType: true,
            awbNo: '',
            fwdNo: '',
            client: '',
            service: '',
            invoiceNo: '',
            bookingDate: '',
            billingWt: '',
            destination: '',
            pkt: '',
            consignorName: '',
            consignorPhone: '',
            consigneeName: '',
            consigneePhone: '',
            deliveryDate: '',
            deliveryStatus: '',
            receivedBy: '',
            remarks: '',
        });
        // clear print shipper url and error
        if (objectURL) {
            URL.revokeObjectURL(objectURL);
            setObjectURL(null);
        }
        if (error) {
            setError(null);
        }
    };

    const handleClick = (e) => {
        e.preventDefault(); // Prevent default hyperlink behavior        

        if (objectURL) {
            // Open PDF in a new window
            window.open(objectURL, '_blank', 'noopener,noreferrer,width=800,height=600,scrollbars=no,resizable=yes');
        } else {
            alert(error); // Show the response error text in an alert
        };
    }

    return { formValues, handleInputChange, loading, modalMessage, modalType, showModal, setShowModal, betterLoggerFunction, handleSearch, handleReset, error, objectURL, handleClick }
}

export default TrackingController;